<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">ios用户充值金额管理</div>
          <span class="m-title-s">对ios用户充值金额管理编辑操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>充值金额选项
          </div>
          <div class="m-table-btn">
            <el-button @click="openForm" type="primary" size="small">新增金额</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="money" label="金额" align="center">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.money }} 元</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openSubForm(scope.row)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 音频编辑 -->
    <el-dialog width="550px" title="编辑信息" :visible.sync="openFormState" @close='closeForm' center :close-on-click-modal="false">
      <div v-loading="formLoading" class="m-open-container">
        <el-form :model="subForm" ref="audioForm" label-width="100px">
          <el-form-item label="金额：">
            <el-input v-model="subForm.money" type="number" placeholder="输入金额"></el-input>
          </el-form-item>
          <div style="text-align: center;">
            <el-button @click="openFormState = false">取 消</el-button>
            <el-button type="primary" @click="submitForm()">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'iosMoney',
  data () {
    return {
      openState: false,
      openFormState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      subForm: {
        id: '',
        money: 0
      }
    }
  },
  methods: {
    closeForm () {
      this.subForm = {
        id: '',
        money: 0
      }
    },
    openForm () {
      this.openFormState = true
    },
    openSubForm (row) {
      this.openFormState = true
      this.subForm = {
        id: row.id,
        money: row.money
      }
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/ios/money/del', {id: id})
          .then((res) => {
            if (res.code === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    submitForm () {
      let _this = this
      _this.formLoading = true
      this.$axios.post('/ios/money/save', _this.subForm)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.listData()
            _this.openFormState = false
          } else {
            _this.$message.error(res.msg)
          }
          _this.formLoading = false
        })
    },
    // 列表
    listData () {
      let _this = this
      _this.isLoading = true
      _this.list = []
      this.$axios.post('/ios/money/list', {})
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ios/IosMoney.vue